import { SectionPage } from "@/components/section-page";
import { useFooterNavigateStyles } from "./footer-navigate.styles";
import { FooterNavigateMenu } from "./footer-navigate-menu";
import { FooterNavigateHelp } from "./footer-navigate-help";
import { FooterNavigateCopyright } from "./footer-navigate-copyright";

export const FooterNavigate = () => {
  const { styles } = useFooterNavigateStyles();

  return (
    <SectionPage classNames={{ body: styles.body }}>
      <FooterNavigateMenu />
      <FooterNavigateHelp />
      <FooterNavigateCopyright />
    </SectionPage>
  );
};
